import { Alert, TypographyProps, Text } from "@chakra-ui/react";
import { IconName, IconPrefix } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const IconAlert = ({
  text,
  mb = "14px",
  whiteSpace = "nowrap",
  status = "info",
}: {
  text: string;
  mb?: string;
  whiteSpace?: TypographyProps["whiteSpace"];
  status?: "info" | "warning" | "success" | "error" | "loading";
}) => {
  let icon: [IconPrefix, IconName] = ["fal", "info-circle"];

  switch (status) {
    case "info":
      icon = ["fal", "info-circle"];
      break;
    case "warning":
      icon = ["fal", "exclamation-triangle"];
      break;
    case "success":
      icon = ["fal", "check-circle"];
      break;
    case "error":
      icon = ["fal", "times-circle"];
      break;
    case "loading":
      icon = ["fal", "spinner-third"];
      break;
    default:
      icon = ["fal", "question-circle"];
  }

  return (
    <Alert
      status={status}
      mb={mb}
      ml={mb === "0px" ? "24px" : "0px"}
      w={mb === "0px" ? "400px" : "auto"}
      fontSize="14px"
      borderRadius="5px"
      whiteSpace={whiteSpace}
      borderWidth="1px"
      // bg="#E2F6FF"
    >
      <FontAwesomeIcon color="#1B83AE" fontSize="16px" icon={icon} />
      <Text ml="8px">{text}</Text>
    </Alert>
  );
};
